import React from "react";
import Button from "./Button"; // ปรับ path ตามจริง
import { XMarkIcon } from "@heroicons/react/24/solid";

const Modal = ({
  title = "",
  show = false,
  destroyOnClose = true,
  closable = false,
  okLabel = "Ok",
  cancelLabel = "Cancel",
  clearLabel = "Clear",
  acceptButton,
  denyButton,
  type = "default",
  buttons = ["ok", "cancel"],
  enabledButtons = true,
  containerClass = "",
  onOk,
  onCancel,
  onClear,
  onClose,
  onAccept,
  onDeny,
  children,
  footerSlot,
}) => {
  if (!show && destroyOnClose) return null;

  const typeClass = {
    primary: "bg-primary text-white",
    danger: "bg-red-500 text-white",
    default: "bg-gray-300 text-black",
  };

  return (
    <div className="fixed inset-0 flex justify-center z-[999] bg-overlay">
      <div className="w-full max-w-md h-screen flex flex-col items-center">
        {closable ? (
          <div className="w-full flex justify-end items-center pt-8 pr-5">
            <button
              onClick={onClose || onCancel}
              className="w-11 h-11 bg-overlay-40 text-secondary-text-invert rounded-full flex justify-center items-center"
            >
              <XMarkIcon className="w-4/5 h-4/5" />
            </button>
          </div>
        ) : (
          <div className="w-full h-11" />
        )}

        <div
          className={`w-screen max-w-md flex flex-col items-center px-5 ${
            closable ? "max-h-[70%]" : "max-h-[75%]"
          } gap-y-5 ${containerClass}`}
        >
          <div className="relative w-full h-full flex flex-col rounded-2xl p-4 bg-secondary-background shadow-lg">
            {(closable || title) && (
              <div className="w-full flex justify-between items-start mb-2">
                <div className="text-lg font-bold text-primary">{title}</div>
              </div>
            )}

            <div className="w-full h-full">{children}</div>

            {(footerSlot || buttons.length > 0) && (
              <div className="mt-4">
                {footerSlot ? (
                  footerSlot
                ) : (
                  <div className="flex flex-col md:flex-row gap-4">
                    {buttons.includes("clear") && (
                      <Button
                        onClick={onClear}
                        className="w-full md:w-32"
                        ghost
                        type={type}
                      >
                        {clearLabel}
                      </Button>
                    )}
                    {buttons.includes("cancel") && (
                      <Button
                        onClick={onCancel}
                        className="w-full md:w-32"
                        ghost
                        type={type}
                      >
                        {cancelLabel}
                      </Button>
                    )}
                    {buttons.includes("ok") && (
                      <Button
                        onClick={onOk}
                        className="w-full md:w-32"
                        type={type === "default" ? "primary" : type}
                      >
                        {okLabel}
                      </Button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {(acceptButton || denyButton) && (
            <div className="w-full flex justify-center gap-4 mt-4">
              {denyButton && (
                <Button
                  disabled={!enabledButtons}
                  className="w-48 h-11 text-lg font-medium"
                  shape="round"
                  type="primary"
                  onClick={onDeny}
                >
                  {denyButton}
                </Button>
              )}
              {acceptButton && (
                <Button
                  disabled={!enabledButtons}
                  className="w-48 h-11 text-lg font-medium"
                  shape="round"
                  type="primary"
                  onClick={onAccept}
                >
                  {acceptButton}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
